export enum HeaderSearchBlock {
  Root = 'HeaderSearch',
}
